import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Stack } from '@mui/material';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '1px solid grey',
  borderRadius: "5px",
  boxShadow: 24,
  p: 4,
};


function CommentModal(props){
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        props.handleCommentModal();
        setOpen(false);
        }
    React.useEffect(()=>{
        if(props.open){
            setOpen(true)
        }
    },[props])
    const BootstrapDialogTitle = (props) => {
        const { children, onClose, ...other } = props;
    
        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {handleClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    };
    console.log(props)
    return(
        <div>
             <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth="sm"
                maxWidth="sm"
            >
                <BootstrapDialogTitle className="modal-heading" id="alert-dialog-title">Manager Comment </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        <Alert severity="info">{props.comment}</Alert>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} variant="outlined" className="theme-btn cancel-btn">Close</Button>
                </DialogActions>

            </Dialog>
        </div>
    )
}
export default CommentModal;